import Login from "./components/Login";
import OMSLogin from "./components/OMSLogin";
import VenderLogin from "./components/VenderLogin";
import Logout from "./components/Logout";
import AuthProvider from "./Auth";
import WorkSelect from "./components/WorkSelect";
import ConfirmationProvider from "./Confirmation";
import ConfirmationFrame from "./components/Confirmation/ConfirmationFrame";
import ConfirmationDelFrame from "./components/Confirmation/ConfirmationDelFrame";
import ChakkoForm from "./components/chakko/StartRopeFrame";
import Chakko from './components/chakko/Chakko';
import JyotoForm from "./components/jyoto/JyotoFrame";
import Jyoto from './components/jyoto/Jyoto';
import ShunkoForm from "./components/shunko/ShunkoFrame";
import Shunko from './components/shunko/Shunko';
import DigitalConstractsProvider from "./DigitalConstracts";
import DigitalConstractFrame from "./components/DigitalConstract/DigitalConstractConstitution/DigitalConstractFrame";
import DigitalConstractCustomerConfirmation from "./components/DigitalConstract/CustomerConfirmation/DigitalConstractCustomerConfirmation"
import DigitalConstractCustomerFrame from "./components/DigitalConstract/CustomerConfirmation/DigitalConstractCustomerFrame"
import DigitalConstractListFrame from "./components/DigitalConstract/DigitalConstractList/DigitalConstractListFrame"
import InspectionMenuFrame from "./components/Inspection/InspectionMenuFrame"
import WarrantyListFrame from "./components/Inspection/Warranty/WarrantyListFrame"
import WarrantyForm from "./components/Inspection/Warranty/WarrantyFrame"
import WarrantyCreatedFrame from "./components/Inspection/Warranty/CreatedFrame"
import PropertyAssignmentFrame from "./components/Inspection/PropertyAssignment/PropertyAssignmentFrame"
import AccountManagementFrame from "./components/Inspection/AccountManagement/AccountManagementFrame"
import CustomerlistFrame from "./components/Inspection/VisitReport/CustomerlistFrame"
import ReportlistFrame from "./components/Inspection/VisitReport/ReportlistFrame"
import VisitReportFrame from "./components/Inspection/VisitReport/VisitReportFrame"
import VisitReportCreatedFrame from "./components/Inspection/VisitReport/CreatedFrame"
import InspectionWarrantyProvider from "./InspectionWarrantyContext"
import LandingPage from "./LandingPage"


const PrivateRoutes = [
    {
        index: true,
        element: <AuthProvider><Login /></AuthProvider>
    },
    {
        path: '/logout',
        element: <AuthProvider> <Logout /></AuthProvider>
    },
    {
        path: '/top',
        element: <AuthProvider> <WorkSelect /></AuthProvider>
    },
    {
        path: '/confirmation/list',
        element: <AuthProvider><ConfirmationProvider><ConfirmationFrame /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/dellist',
        element: <AuthProvider><ConfirmationProvider><ConfirmationDelFrame /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/chakko/edit',
        element: <AuthProvider><ConfirmationProvider><ChakkoForm /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/chakko/chakko',
        element: <AuthProvider><ConfirmationProvider><Chakko /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/jyoto/edit',
        element: <AuthProvider><ConfirmationProvider><JyotoForm /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/jyoto/jyoto',
        element: <AuthProvider><ConfirmationProvider><Jyoto /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/shunko/edit',
        element: <AuthProvider><ConfirmationProvider><ShunkoForm /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/confirmation/shunko/shunko',
        element: <AuthProvider><ConfirmationProvider><Shunko /></ConfirmationProvider></AuthProvider>
    },
    {
        path: '/digitalconstract',
        element: <AuthProvider><DigitalConstractsProvider><DigitalConstractFrame /></DigitalConstractsProvider></AuthProvider>
    },
    {
        path: '/digitalconstract/customerconfirm',
        element: <AuthProvider><DigitalConstractsProvider><DigitalConstractCustomerFrame /></DigitalConstractsProvider></AuthProvider>
    },
    {
        path: '/digitalconstract/list',
        element: <AuthProvider><DigitalConstractsProvider><DigitalConstractListFrame /></DigitalConstractsProvider></AuthProvider>
    },
    {
        path: '/OMSUser',
        element: <AuthProvider><OMSLogin /></AuthProvider>
    },
    {
        path: '/vender',
        element: <AuthProvider><VenderLogin /></AuthProvider>
    },
    {
        path: '/inspection',
        element: <AuthProvider><InspectionMenuFrame /></AuthProvider>
    },
    {
        path: '/inspection/shorttermWarranty/list',
        element: <AuthProvider><WarrantyListFrame /></AuthProvider>
    },
    {
        path: '/inspection/longtermWarranty/list',
        element: <AuthProvider><WarrantyListFrame /></AuthProvider>
    },
    {
        path: '/inspection/visitReport/customerlist',
        element: <AuthProvider><CustomerlistFrame /></AuthProvider>
    },
    {
        path: '/inspection/visitReport/customerlist/reportlist',
        element: <AuthProvider><ReportlistFrame /></AuthProvider>
    },
    {
        path: '/inspection/propertyAssignment/list',
        element: <AuthProvider><PropertyAssignmentFrame /></AuthProvider>
    },
    {
        path: '/inspection/accountManagement/list',
        element: <AuthProvider><AccountManagementFrame /></AuthProvider>
    },
    {
        path: '/inspection/shorttermWarranty/edit',
        element: <AuthProvider><InspectionWarrantyProvider><WarrantyForm /></InspectionWarrantyProvider></AuthProvider>
    },
    {
        path: '/inspection/shorttermWarranty/confirm',
        element: <AuthProvider><InspectionWarrantyProvider><WarrantyForm /></InspectionWarrantyProvider></AuthProvider>
    },
    {
        path: '/inspection/shorttermWarranty/shorttermWarranty',
        element: <AuthProvider><InspectionWarrantyProvider><WarrantyCreatedFrame /></InspectionWarrantyProvider></AuthProvider>
    },
    {
        path: '/inspection/longtermWarranty/edit',
        element: <AuthProvider><WarrantyForm /></AuthProvider>
    },
    {
        path: '/inspection/longtermWarranty/confirm',
        element: <AuthProvider><WarrantyForm /></AuthProvider>
    },
    {
        path: '/inspection/longtermWarranty/longtermWarranty',
        element: <AuthProvider><WarrantyCreatedFrame /></AuthProvider>
    },
    {
        path: '/inspection/visitReport/edit',
        element: <AuthProvider><VisitReportFrame /></AuthProvider>
    },
    {
        path: '/inspection/visitReport/confirm',
        element: <AuthProvider><VisitReportFrame /></AuthProvider>
    },
    {
        path: '/inspection/visitReport/visitReport',
        element: <AuthProvider><VisitReportCreatedFrame /></AuthProvider>
    },
    {
        path: '/LandingPage',
        element: <AuthProvider><LandingPage /></AuthProvider>
    }
];

export default PrivateRoutes;
